// Dismiss buttons on the server-rendered flash (app/views/shared/_flash.html.erb).
// The SPA mounts below the flash and keeps it on screen across in-app
// navigation, so a person has to be able to close it.
export function setupFlash() {
  document.querySelectorAll("[data-flash-dismiss]").forEach((button) => {
    button.addEventListener("click", () => button.closest("[data-flash]")?.remove())
  })
}
